import React from 'react';
import styled from 'styled-components';
import { array, bool } from 'prop-types';

const VisualTagBox = styled.span`
  opacity: ${({ disabled }) => (disabled ? 0.4 : 1)};
`;

const Text = styled.span`
  white-space: nowrap;
  vertical-align: middle;
  height: 18px;
  background-color: #6e0ad6;
  color: #FFF;
  border-radius: 4px 0px 4px 0px;
  padding: 2px 8px;
  margin: 0px 3px;
  font-size: 10px;
  font-weight: bold;
  text-transform: uppercase;
  border-radius: 100px;
  background-color: #28B5D9;
`;

const HelpIcon = styled.img`
  vertical-align: middle;
  width: 16px;
  height: 16px;
  cursor: pointer;
`;

const VisualTag = ({ children, disabled, help }) => (
  <VisualTagBox disabled={disabled}>
    <Text>
      {children}
    </Text>
    { help && <HelpIcon src={`${process.env.PUBLIC_URL}/images/help-circle-grey.svg`} /> }
  </VisualTagBox>
);

VisualTag.propTypes = {
  children: array.isRequired,
  disabled: bool,
  help: bool,
};

VisualTag.defaultProps = {
  help: false,
  disabled: false,
};

export default VisualTag;
